import { track, logError } from '@tracking';
import getShopId from '@core/reducers/shop/selectors/getShopId';
import getMenuProducts from '@core/reducers/menu/selectors/getMenuProducts';
import { getSection } from '@core/reducers/menu/selectors/getMenuSection';
import { getRouterLocation } from '@shared/selectors';

const EVENT_NAME = 'before_price_products.loaded ';
const NOT_SET = '(not set)';
const BEFORE_PRICE = 'beforePrice';
const SECTION = 'seccion';
const MENU = 'menu';
const BUSCAR = 'buscar';
const SEARCH = 'search';

let productsWithBeforePriceCampaigns = [];

function checkIfDataisAlreadyAdded(productData, newProduct) {
  const BEFORE_PRICE_ID = 0;
  const PRODUCT_ID = 1;
  if (
    (productData.includes(newProduct[BEFORE_PRICE_ID]) &&
      productData.includes(String(newProduct[PRODUCT_ID]))) ||
    productData.includes(`+${newProduct[PRODUCT_ID]}`)
  ) {
    return true;
  }
  return false;
}

function checkIfCampaignisAlreadyAdded(trackData, campaign, productId) {
  const CAMPAIGN_ID = 0;
  const PRODUCT_ID_CONUTER = 2;
  if (
    (trackData[CAMPAIGN_ID] === campaign.id &&
      trackData.includes(String(productId)) === false) ||
    trackData.includes(`+${productId}`)
  ) {
    // eslint-disable-next-line no-param-reassign
    trackData[PRODUCT_ID_CONUTER] += 1;
    trackData.push(`+${productId}`);
    return true;
  }
  return false;
}

function addNewCampaign(product, hasBeforePrice) {
  let itemNumber = 0;
  itemNumber += 1;
  productsWithBeforePriceCampaigns.push([
    hasBeforePrice.id,
    ':',
    itemNumber,
    '|',
    String(product.id),
  ]);
}

function addProductWithCampaign(product) {
  if (product.campaigns) {
    const hasBeforePrice = product.campaigns.find(
      campaign => campaign.type === BEFORE_PRICE,
    );
    if (hasBeforePrice) {
      let isAdded = false;
      if (productsWithBeforePriceCampaigns.length > 1) {
        productsWithBeforePriceCampaigns.forEach(function callback(newProduct) {
          isAdded = checkIfDataisAlreadyAdded(newProduct, [
            hasBeforePrice.id,
            product.id,
          ]);
        });
        if (!isAdded) {
          productsWithBeforePriceCampaigns.forEach(function callback(item) {
            isAdded = checkIfCampaignisAlreadyAdded(
              item,
              hasBeforePrice,
              product.id,
            );
          });
        }
      } else if (productsWithBeforePriceCampaigns.length === 1) {
        isAdded = checkIfDataisAlreadyAdded(
          productsWithBeforePriceCampaigns[0],
          [hasBeforePrice.id, product.id],
        );
        if (!isAdded) {
          const wasTheCampaignAdded = checkIfCampaignisAlreadyAdded(
            productsWithBeforePriceCampaigns[0],
            hasBeforePrice,
            product.id,
          );
          if (!wasTheCampaignAdded) {
            addNewCampaign(product, hasBeforePrice);
          }
        }
      } else {
        addNewCampaign(product, hasBeforePrice);
      }
    }
  }
}

function castArray() {
  let dataJoinCounter = 0;
  const stringDataContainer = [];
  if (productsWithBeforePriceCampaigns) {
    while (productsWithBeforePriceCampaigns.length > dataJoinCounter) {
      stringDataContainer.push(
        productsWithBeforePriceCampaigns[dataJoinCounter].join(''),
      );
      dataJoinCounter += 1;
    }
    const listedInfoData = stringDataContainer.join(';');
    return listedInfoData;
  }
  return null;
}

function getListeInfo(products) {
  products.forEach(addProductWithCampaign);
  return castArray();
}

function obtainExpectedOrigin(routerState) {
  if (routerState.pathname.indexOf(SECTION) !== -1) {
    return SECTION;
  }
  if (
    routerState.pathname.indexOf(MENU) !== -1 &&
    routerState.pathname.indexOf(BUSCAR) === -1
  ) {
    return MENU;
  }
  if (routerState.pathname.indexOf(BUSCAR) !== -1) {
    return SEARCH;
  }
  return NOT_SET;
}

function setProducts({ section, origin, products, searchData }) {
  if (section !== null) {
    return section.products;
  }
  if (origin === SEARCH) {
    return searchData;
  }
  return products;
}

const trackBeforePriceProductsLoaded = (
  searchData = null,
  sectionId = null,
) => (_, getState) => {
  try {
    const state = getState();
    const routerState = getRouterLocation(state);
    const shopId = getShopId(state);
    let products = getMenuProducts(state);
    const section = getSection(state, sectionId);
    const origin = obtainExpectedOrigin(routerState);
    products = setProducts({ section, origin, products, searchData });
    const listedInfo = getListeInfo(products);
    productsWithBeforePriceCampaigns = [];

    const payload = {
      listedInfo,
      shopId,
      origin,
    };
    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackBeforePriceProductsLoaded;
